/**
 * Port von `Shared/AuthLayout.razor`.
 *
 * Die dort bedingt eingebundene `<LoginDisplay />` entfällt: Die Anmeldelogik läuft in React
 * zentral im `AuthProvider` und nicht im Layout.
 */

import type { ReactElement, ReactNode } from 'react';

export function AuthLayout({ children }: { children: ReactNode }): ReactElement {
  return (
    <div className="iwm-auth-layout">
      <div className="iwm-auth-page-left-section"></div>
      <div className="iwm-auth-page-main-section">{children}</div>
    </div>
  );
}

export default AuthLayout;
